(function() {
	
	'use strict';
    
	var formValidator;
    var expanded = false;
    
    /* Compile customized UNY fields */
    var pmiunyFields = function($form) {
        var $qs = $form.has('.pmiuny-event-signup-questions');
        if ($qs.length) {
            var v = '';
            var partNumber = 0;
            
            $qs.find('[name^="metaData_part"]').each(function(i, el) {
                if (el.type === 'radio' || el.type === 'checkbox') {
                    if (el.checked) {
                        partNumber++;
                        v += $qs.find('.metaData_label' + partNumber).text() + ' = ' + el.value;
                        v += '; \n';
                    }
                } else {
                    partNumber++;
                    if (el.value !== '') {
                        v += el.parentElement.querySelector('.form-input-label').textContent + ' = ' + el.value;
                        v += '; \n';
                    }
                }
            });
            
            $form.find('[name="metaData"]').each(function() {
                if (this.value !== '') {
                    v = this.value + '; \n' + v;
                }
                this.name = 'metaDataX';
            });
            $qs.find('[name="metaDataCompile"]').val(v).attr('name', 'metaData');
        }
    };
    
    /* Compile dynamically event's extra fields */
    var compileMetaData = function($form) {
        var $parts = $form.find('.event-signup-metadata-part');
        if ($parts.length) {
            var v = '';

            $parts.each(function(i, el) {
                var input = $(el).find('.esmp-input')[0];
                var labelEl = $form.find(input.getAttribute('data-extra'))[0];
                var line = '';

                if (input && input.value.trim() !== '') {
                    // Append the meta label
                    if (labelEl && labelEl.value.trim() !== '') {
                        line += labelEl.value.trim();
                        if (!line.match(': ')) {
                            line += ' = ';
                        }
                    }
                    // Append the meta value
                    line += input.value.trim();
                }
                // Append the meta line to the main value
                if (line !== '') {
                    v += (v !== '' ? '; \n' : '') + line;
                }
            });
            if($('input[name="metaData"]').length != 0) {
                $('input[name="metaData"]').val(v);
            }
            else {
                $form.append('<input type="hidden" name="metaData" value="' + v.replace(/"/g, "&quot;") + '"/>');
            }
        }
    };

	var submitEventSignup = function() {
		var btn = $(this);
		var form = btn.closest('form');
		var count = form.find('input[name=participants-count]').val();
		var inputsFilled = false;

		form.removeClass('has-error');
		$('.js-form-error-message.fields').slideUp();

		form.find('.form-input.required').each(function() {
			if (this.value.trim() !== '') {
                $(this).removeClass('error');
				inputsFilled = true;
			}
		});
        pmiunyFields(form);
        compileMetaData(form);

		if (parseInt(count) === 0 || inputsFilled) {
			formValidator.validateForm(form);
		}

		if (!form.hasClass('has-error')) {
			$('.event-signup-form-btns .btn', form).addClass('disabled');

            var forward = btn.attr('data-url');
			if (inputsFilled) {
				form.find('input[name=pageSuccess]').val(forward);
                setTimeout(function() {
                    form.submit();
                }, 50);
            } else {
                window.location.href = forward;
            }
		}
	};
	

    function getCheckedValues() {
        var selectedAddPriceId = [];
        $("input[type='checkbox']:checked").each(function () {
            if($(this).val() != 'on')
                selectedAddPriceId.push($(this).val());
        });

        $('.event-signup-form input[name="addPriceId"]').val(selectedAddPriceId.join(','));
        console.log(selectedAddPriceId.join(','));
        // Do something with the checked values
    }

	$(window).ready(function() {
        formValidator = Fw.component.models().form;

		$('.submit-event-signup-btn').click(submitEventSignup);
        $('.add-guest-btn').click(submitEventSignup);
        $(".selectBox").on("click", function () {
            var checkboxes = $("#checkboxes");
            if (!expanded) {
                checkboxes.show();
                expanded = true;
            } else {
                checkboxes.hide();
                expanded = false;
            }
        });
        $("#checkboxes input[type='checkbox']").on("change", getCheckedValues);
    });
	
})();
